<template>
  <div class="account-management">
    <div class="incentive-content">
      <div class="top-info">
        <!-- 门店参与人 -->
        <span class="info-title">{{ $t('shared.storeParticipant') }}</span>
      </div>
      <div class="incentive-item" v-for="(subItem, subIndex) in employeeList" :key="subIndex">
        <div class="item-left">
          <div class="user-info">
            <span class="user-name txt-ellipsis">{{ subItem.nickname }}</span>
            <span class="user-type txt-ellipsis" :style="{ 'color': subItem.jobColor, 'border': `1px solid ${subItem.jobColor}` }">{{ subItem.job }}</span>
          </div>
          <!-- <div class="phone txt-ellipsis">Phone: {{ subItem.phone | phoneFormat }}</div> -->
          <div class="phone txt-ellipsis">{{ $t('form.phone') }}: +{{ subItem.countryCode }} {{ subItem.phone }}</div>
        </div>
        <div class="item-right">
          <img class="icon-img" src="@/assets/images/qr_code.png" alt="" @click="handleOper('code', subItem)">
          <img class="icon-img" src="@/assets/images/incentive_edit.png" alt="" @click="handleOper('edit', subItem)">
          <img v-if="customerInfo.isAllot === 1" class="icon-img" src="@/assets/images/event_del.png" alt="" @click="handleOper('del', subItem)">
        </div>
      </div>
      <van-empty v-if="employeeList.length <= 0" :description="$t('form.noData')" />
    </div>
    <van-dialog v-model="dialogShow" :title="`${currentData.nickname}'s Incentive Link`" :showConfirmButton="false">
      <div class="dialog-content">
        <div v-if="codeUrl" class="qrcode-section" ref="qrCodeRef"></div>
        <div class="link-txt txt-ellipsis">
          <a :href="codeUrl" target="_black">{{ codeUrl }}</a>
        </div>
        <div class="link-tip">{{ $t('tips.messgaeTwenty') }}</div>
        <div class="dialog-btn">
          <van-button color="#307bff" class="xu-btn copy-notice" size="small" type="info" @click="handleDialog('copy')">{{ $t('buttom.copyLink') }}</van-button>
          <!-- <van-button color="#307bff" class="xu-btn copy-notice" size="small" plain type="info" @click="handleDialog('copy')">Copy</van-button> -->
          <van-button color="#307bff" class="xu-btn" size="small" plain type="info" @click="handleDialog('close')">{{ $t('button.close') }}</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Notify, Toast, Dialog } from 'vant'
import Clipboard from 'clipboard'
import { arsSmsTextApi, arsDeleteEmployeeApi, arsSendSmsTextApi, activityEmployeeQrCodeApi } from '@/api/home'
import QRCode from 'qrcodejs2'
export default {
  props: {
    customerId: {
      type: String,
      default: ''
    },
    employeeList: {
      type: Array,
      default: () => []
    },
    customerInfo: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    phoneFormat (val) {
      if (!val) {
        return ''
      }
      return val.replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3')
    }
  },
  data () {
    return {
      dialogShow: false,
      noticeContent: '',
      currentData: {},
      qrcodeUrl: null,
      codeUrl: ''
    }
  },
  methods: {
    handleOper (type, params) {
      this.currentData = params
      if (type === 'send') {
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsSmsTextApi(params.id).then((result) => {
          Toast.clear()
          this.noticeContent = result.data
          this.dialogShow = true
        })
      } else if (type === 'edit') {
        this.$router.push(
          `/storeIncentive/create?customerId=${this.customerId}&employeeId=${params.id}`
        )
      } else if (type === 'del') {
        Dialog.confirm({
          title: this.$t('shared.title.prompt'),
          message: this.$t('shared.titleEighteen'), // 是否确认移除该人员的活动参与资格？
          confirmButtonText: this.$t('button.remove')
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            arsDeleteEmployeeApi({ ids: [params.id] }).then((res) => {
              Toast.clear()
            })
          })
          .catch(() => {
            // on cancel
          })
      } else if (type === 'code') {
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        this.codeUrl = ''
        this.qrcodeUrl = null
        activityEmployeeQrCodeApi(params.id).then(res => {
          Toast.clear()
          this.dialogShow = true
          this.codeUrl = res.data
          this.$nextTick(() => {
            // console.log('this.$refs.qrCodeRef', this.$refs.qrCodeRef.offsetWidth, this.$refs.qrCodeRef.offsetHeight) // document.getElementById('pageHeader').offsetHeight
            if (this.qrcodeUrl) {
              this.qrcodeUrl.clear()
              this.qrcodeUrl.makeCode(res.data)
            } else {
              this.qrcodeUrl = new QRCode(this.$refs.qrCodeRef, {
                text: res.data,
                width: this.$refs.qrCodeRef.offsetWidth,
                height: this.$refs.qrCodeRef.offsetHeight,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.M
              })
            }
          })
        })
      }
    },
    handleDialog (type) {
      if (type === 'send') {
        Dialog.confirm({
          title: this.$t('shared.title.prompt'),
          message: this.$t('shared.titleNineteen'),
          confirmButtonColor: '#307bff'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            arsSendSmsTextApi(this.currentData.id).then((res) => {
              Toast.clear()
              Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
            })
          })
          .catch(() => {
            // on cancel
          })
      } else if (type === 'copy') {
        const clipboard = new Clipboard('.copy-notice', {
          text: () => this.codeUrl
        })

        clipboard.on('success', () => {
          Notify({ type: 'success', message: this.$t('tips.noticeCopiedSuccessfully'), duration: 1500 })
          // 清理，防止多次触发
          clipboard.destroy()
        })

        clipboard.on('error', (err) => {
          console.log('error', err)
          Notify({ type: 'warning', message: this.$t('tips.noticeCopiedFailed'), duration: 1500 })
          // 清理，防止多次触发
          clipboard.destroy()
        })
      }
      this.qrcodeUrl = null
      this.dialogShow = false
    },
    handleSave () {
      const qrCodeDiv = this.$refs.qrCodeRef
      if (!qrCodeDiv) return

      let imgUrl = ''
      // qrcodejs2 生成的结构中可能包含 img 或 canvas
      const img = qrCodeDiv.querySelector('img')
      if (img && img.src) {
        imgUrl = img.src
      } else {
        const canvas = qrCodeDiv.querySelector('canvas')
        if (canvas) {
          imgUrl = canvas.toDataURL('image/png')
        }
      }

      if (imgUrl) {
        const link = document.createElement('a')
        link.href = imgUrl
        link.download = `Invite_QRCode_${new Date().getTime()}.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // H5 无法直接操作相册，提示用户长按保存
        Toast(this.$t('tips.messageTwentyOne'))
      } else {
        Toast(this.$t('tips.messageTwentyTwo'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.account-management {
  font-size: 13px;
  .tabs-content {
    display: flex;
    align-items: center;
    padding: 20px 10px;
    background-color: #fff;
    .tab-item {
      padding: 5px 26px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: bold;
      font-size: 13px;
    }
    .active-item {
      color: #fff;
      background-color: #307bff;
    }
  }
  /deep/.van-tabs {
    .van-tabs__nav {
      margin: 0 10px;
      .van-tab__text {
        font-size: 12px;
        font-weight: bold;
      }
    }
    .van-tab--disabled {
      border-color: #fff !important;
    }
  }
  .top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid rgba(210, 220, 236, .5);
    .info-title {
      font-weight: bold;
    }
  }
  .incentive-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid rgba(210, 220, 236, .5);
    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .user-name {
        max-width: 150px;
      }
      .user-type {
        max-width: 85px;
        padding: 2px 5px;
        text-align: center;
        border: 1px solid #307bff;
        color: #307bff;
        margin-left: 5px;
        font-size: 12px;
      }
    }
    .phone {
      max-width: 240px;
    }
    .item-right {
      display: flex;
      justify-content: space-between;
      width: 80px;
    }
  }
  .icon-img {
    width: 20px;
    height: 20px;
  }
  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px;
    font-size: 14px;
    .qrcode-section {
      width: 166px;
      height: 166px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .link-txt {
      width: 200px;
      >a {
        color: #307bff;
      }
    }
    .link-tip {
      font-size: 11px;
      margin-top: 10px;
    }
    .dialog-btn {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      .xu-btn {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
